module.exports = __webpack_public_path__ + "media/images/writer/community/sp-title@2x-f416855b42400385c10545d471e2d395.png";